import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
//import registerServiceWorker from "./registerServiceWorker"

import picturefill from "picturefill";
import "lazysizes/plugins/object-fit/ls.object-fit";
import lazysizes from "lazysizes";

picturefill();
// window.lazySizesConfig = window.lazySizesConfig || {}
// window.lazySizesConfig.init = false
// window.lazySizesConfig.loadMode = 3
// lazysizes.init()

ReactDOM.render(<App />, document.getElementById("root"));

//registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js